import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { gladstoneConfig } from "./data";

export default function GladstonePage() {
  return <OregonCityPageTemplate config={gladstoneConfig} />;
}